export default "__VITE_ASSET__D9bZ56nr__"